'use client';

import FloatBottomTips from '@/components/address/FloatBottomTips';
import DownloadBar from '@/components/headerFooter/header/components/downloadBar';
import MainHeader from '@/components/headerFooter/header/components/mainHeader';
import MainSideMenu from '@/components/headerFooter/header/components/mainSideMenu';
import SearchBar from '@/components/headerFooter/header/components/searchBar';
import HEADER_PAGE_TYPE from '@/constants/header';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useStores } from '@/models';

export interface IHeaderProps {
  pageType: keyof typeof HEADER_PAGE_TYPE; // 确保 `pageType` 的类型与 HEADER_PAGE_TYPE 的键一致
  disabled?: boolean;
}

const JDIHeader = observer(
  ({ pageType = HEADER_PAGE_TYPE.NORMAL, disabled = false }: IHeaderProps) => {
    const pageConfig: Record<
      keyof typeof HEADER_PAGE_TYPE,
      {
        showDownloadBar: boolean;
        showMainHeader: boolean;
        showSearchBar: boolean;
        showLocationErrorTips: boolean;
      }
    > = {
      [HEADER_PAGE_TYPE.HOME]: {
        showDownloadBar: true,
        showMainHeader: true,
        showSearchBar: true,
        showLocationErrorTips: true,
      },
      [HEADER_PAGE_TYPE.MINIHOME]: {
        showDownloadBar: true,
        showMainHeader: true,
        showSearchBar: true,
        showLocationErrorTips: true,
      },
      [HEADER_PAGE_TYPE.NORMAL]: {
        showDownloadBar: true,
        showMainHeader: true,
        showSearchBar: false,
        showLocationErrorTips: false,
      },
      [HEADER_PAGE_TYPE.PROMOTION]: {
        // 券促页 包邮走这类 其他走NORMAL
        showDownloadBar: false,
        showMainHeader: true,
        showSearchBar: false,
        showLocationErrorTips: false,
      },
    };

    const { cartNumStore, userInfoStore } = useStores();
    const [isShowMainSideMenu, setIsShowMainSideMenu] = useState(false); // 是否展示侧边菜单

    useEffect(() => {
      cartNumStore.fetchCartNum();
      userInfoStore.fetchUserInfo();
    }, [cartNumStore, userInfoStore]);

    const showObjs = pageConfig[pageType] || pageConfig[HEADER_PAGE_TYPE.NORMAL];

    return (
      <div className={`${styles.headerWrap} ${disabled ? styles.disabled : ''}`}>
        {showObjs.showDownloadBar && (
          <div className={styles.downloadBarWrapper}>
            <DownloadBar />
          </div>
        )}
        {showObjs.showMainHeader && <MainHeader setIsShowMainSideMenu={setIsShowMainSideMenu} />}
        {showObjs.showSearchBar && <SearchBar />}
        {isShowMainSideMenu && (
          <MainSideMenu
            accountData={userInfoStore?.accountData}
            setIsShowMainSideMenu={setIsShowMainSideMenu}
          />
        )}
        {showObjs.showLocationErrorTips && <FloatBottomTips />}
      </div>
    );
  },
);

export default JDIHeader;
